import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Select from './SelectFilter'

export const SitesStatuses = ({ sites, onChange, values = [] }) => {
  const { t } = useTranslation()

  const countUp = useMemo(() => {
    return sites.filter(({ equipment }) => equipment.available_level === 'up').length
  }, [sites])

  const countDegraded = useMemo(() => {
    return sites.filter(({ equipment }) => equipment.available_level === 'degraded').length
  }, [sites])

  const countNotReferenced = useMemo(() => {
    return sites.filter(({ equipment }) => equipment.available_level === 'notReferenced').length
  }, [sites])

  const countDown = useMemo(() => {
    return sites.filter(({ equipment }) => equipment.available_level === 'down').length
  }, [sites])

  const choices = useMemo(() => {
    return [
      {
        label: t('supervision.status_availability.up'),
        value: 'up',
        count: countUp,
        id: 1
      },
      {
        label: t('supervision.status_availability.degraded'),
        value: 'degraded',
        count: countDegraded,
        id: 2
      },
      {
        label: t('supervision.status_availability.down'),
        value: 'down',
        count: countDown,
        id: 3
      },
      {
        label: t('supervision.status_availability.notReferenced'),
        value: 'notReferenced',
        count: countNotReferenced,
        id: 4
      }
    ]
  }, [sites])

  const choicesFiltered = choices?.filter(choice => choice.count > 0)

  return (
    <Select
      mainField="label"
      placeholder={t('supervision.status_placeholder')}
      selectedMessageKey={'supervision.filters.selected_status_placeholder'}
      options={choicesFiltered}
      values={values}
      onChange={onChange}
    />
  )
}

const SitesHardwares = ({ sites, onChange, values = [] }) => {
  const { t } = useTranslation()

  const countAp = useMemo(() => {
    return sites.reduce((acc, site) => acc + site.equipment.nb_accesspoints, 0)
  }, [sites])

  const countSwitches = useMemo(() => {
    return sites.reduce((acc, site) => acc + site.equipment.nb_switches, 0)
  }, [sites])

  const countEegs = useMemo(() => {
    return sites.reduce((acc, site) => acc + site.equipment.nb_esls, 0)
  }, [sites])

  const countTvs = useMemo(() => {
    return sites.reduce((acc, site) => acc + site.equipment.nb_tvs, 0)
  }, [sites])

  const countChromecasts = useMemo(() => {
    return sites.reduce((acc, site) => acc + site.equipment.nb_chromecasts, 0)
  }, [sites])

  const choices = useMemo(() => {
    return [
      {
        label: t('supervision.device_type.aps'),
        value: 'ap',
        count: countAp,
        id: 1
      },
      {
        label: t('supervision.device_type.switches'),
        value: 'switches',
        count: countSwitches,
        id: 2
      },
      {
        label: t('supervision.device_type.eegs'),
        value: 'esls',
        count: countEegs,
        id: 3
      },
      {
        label: t('supervision.device_type.tvs'),
        value: 'tvs',
        count: countTvs,
        id: 4
      },
      {
        label: t('supervision.device_type.chromecasts'),
        value: 'chromecasts',
        count: countChromecasts,
        id: 5
      }
    ]
  }, [sites])

  const choicesFiltered = choices.filter(choice => choice.count > 0)

  return (
    <Select
      mainField="label"
      placeholder={t('supervision.device_select_placeholder')}
      noOptionsMessage={t('supervision.device_select_none')}
      selectedMessageKey={'supervision.filters.selected_hardwares_placeholder'}
      options={choicesFiltered}
      onChange={onChange}
      values={values}
    />
  )
}

export default SitesHardwares
